import { put, call, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';

import {
  FETCH_SECURITY_COMPANY_SERVICES,
  setSecurityCompanyServices,
  setSecurityCompanyDetail,
  setSecurityBillingInfo,
  FETCH_SECURITY_COMPANY_DETAIL,
  UPDATE_SECURITY_COMPANY,
  FETCH_VIEW_SECURITY_COMPANY_LIST,
  setViewSecurityCompanyList,
  FETCH_BILLING_INFO,
  setViewSecurityCompanyFilterkey,
} from 'reducers/securityCompany';
import API from 'services/api';
import { showSnackbar, setLoading, toggleModal } from '../../reducers/ui';
import { errorHandler } from '../../utils/errorMessages';
import { transform } from 'utils/DataTransform/SecurityCompanies/securityCompaniesList';
import languages from 'static/languages.json';

// This generator function is for all other user type
export function* fetchSecurityCompanyDetailsLimited({ id }) {
  try {
    const { data } = yield call(API.fetchSecurityCompanyServicesById, id);
    const { languages } = data.data;
    if (data.data !== null) {
      const availableLanguages = setLanguageArray(languages);

      yield put(
        setSecurityCompanyServices({
          ...data.data,
          availableLanguages,
        }),
      );
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

const setLanguageArray = langArray => {
  return languages
    .filter(f => langArray.includes(f.code))
    .map(m => ({
      id: m.code.toLowerCase(),
      region: m.code,
      label: m.name,
    }));
};

// this generator function is for account holders
export function* fetchSecurityCompanyDetails({ id }) {
  try {
    const { data } = yield call(API.fetchSecurityCompanyById, id);
    // const { subscriptions } = data.data;
    const { languages } = data.data;
    const availableLanguages = setLanguageArray(languages);
    if (data.data !== null) {
      yield put(
        setSecurityCompanyDetail({
          ...data.data,
          availableLanguages,
        }),
      );
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* fetchBillingInfo() {
  try {
    yield put(setLoading(true));
    const { data: billingInfo } = yield call(
      API.fetchSecurityCompanyBillingInfo,
    );
    if (billingInfo.data !== null) {
      yield put(setSecurityBillingInfo(billingInfo.data));
    }
    yield put(setLoading(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* updateSecurityCompany({
  id,
  securityCompany,
  toggleLocation,
}) {
  try {
    yield put(setLoading(true));

    const { data } = yield call(API.updateSecurityCompany, id, securityCompany);
    if (data.data !== null) {
      yield call(fetchSecurityCompanyDetails, { id });

      if (toggleLocation) {
        yield put(toggleModal(toggleLocation));
      }
    }
    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* fetchViewSecurityCompanyList({ filters, location }) {
  try {
    const { data } = yield call(API.fetchSecurityCompanies, filters);

    if (data.data !== null) {
      yield put(
        setViewSecurityCompanyList({
          list: transform(data.data),
          totalEntries: get(data, 'meta.total'),
          location,
        }),
      );
      yield put(setViewSecurityCompanyFilterkey({ location, key: false }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* securityCompanySagas() {
  yield takeLatest(FETCH_BILLING_INFO, fetchBillingInfo);
  yield takeLatest(
    FETCH_SECURITY_COMPANY_SERVICES,
    fetchSecurityCompanyDetailsLimited,
  );
  yield takeLatest(FETCH_SECURITY_COMPANY_DETAIL, fetchSecurityCompanyDetails);
  yield takeLatest(UPDATE_SECURITY_COMPANY, updateSecurityCompany);
  yield takeLatest(
    FETCH_VIEW_SECURITY_COMPANY_LIST,
    fetchViewSecurityCompanyList,
  );
}
